import FDictionary from '../__select';
import Form from './Form';

export default class FDictionaryServiceDescription1 extends FDictionary {
  dictionary = 'AddDescription1';

  permissionAdd = [114];

  constructor(props) {
    super(props);
    if (props.service) {
      this.service = props.service;
    }
  }

  get service() {
    return this.refs.data.service;
  }

  set service(value) {
    if (!value) {
      return;
    }
    this.refs.data.service = value;
    this.refs.set('service', value);
  }

  getOptions(model = this.refs.data) {
    if (!model.service) {
      return Promise.resolve(this.setOptions([]));
    }
    return super.getOptions(model);
  }

  addForm() {
    const item = new Form();
    item.init()
      .then(() => {
        if (this.service) {
          item.service.value = this.service;
          item.service.disabled = true;
        }
      });
    return item;
  }
}
